export enum SampleType {
  Trigger,
  Template,
  Workflow
}
